import {
    sliderImage,
    image7,
    blog6,
    blog5,
    // blog3,
    // blog2,
    // blog4,
    // blog1,
    team5,
    team7,
    team1,
    team4, team2, team3, team6
} from 'assets/images';
import Brand from 'components/Brand';
import React, { Component } from "react";
import PageHelmet from "components/common/Helmet";
import Breadcrumb from "components/common/Breadcrumb";
// import CounterOne from "components/counters/CounterOne";
import Testimonial from "components/Testimonial";
// import BrandTwo from "components/BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import { Parallax } from 'react-parallax';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";


class About extends Component{
    render(){
        let title = 'Who we are',
        description = 'Infinity Comics is a media service provider and production company that offers multifarious online streaming content with African niche. The  wide range of content includes a library of films and television programs.';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='About' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'About'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div id="about" className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src={blog6} alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">{title}</h2>
                                            <p className="description">{description}</p>
                                        </div>
                                        <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">What we do</h3>
                                                    <p>The company shall offer high quality online streaming services through a monthly/yearly subscription model. The business model adopted intends to generate supplementary revenue through advertisements.</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">How we do it</h3>
                                                    <p>The Infinity Comics mode of operation consists of consists of acquisition of film and other motion pictures from the legal and patent owners through contractual relations, in-house production of original content and commission content producers.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area  */}

                {/* /!* Start CounterUp Area *!/*/}
                {/* <div className="rn-counterup-area pb--120 bg_color--1">*/}
                {/*    <div className="container">*/}
                {/*        <div className="row">*/}
                {/*            <div className="col-lg-12">*/}
                {/*                <div className="section-title text-center">*/}
                {/*                    <h3 className="fontWeight500">Our Fun Facts</h3>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        <CounterOne />*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*/!* End CounterUp Area *!/*/}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">What else ?</h4>
                                <p>Infinity Comics offers both domestic and International streaming to tap into the local and international market base with specialised Africa based content. The ultimate goal is to redefine the Ugandan/African film industry with a digitalised service and unlocking the industry's potential through massive investment.</p>
                                <a className="rn-btn btn-white" href="/register">Get Started Now</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src={sliderImage} alt="Finding Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>Meet the amazing team and brains curating this hostile take-over.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team5} alt="Mark Tusiime"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Mark Tusiime</h4>
                                        <p className="designation">CEO and Founder</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team7} alt="Barry Ainomugisha"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Barry Ainomugisha</h4>
                                        <p className="designation">COO & Co-founder.</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team1} alt="Collins Mbulakyalo"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Collins Mbulakyalo</h4>
                                        <p className="designation">CTO & Co-founder</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team4} alt="Vanessa Murungi Kusemererwa"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Vanessa Murungi Kusemererwa</h4>
                                        <p className="designation">Manager</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team6} alt="Simon Arinaitwe"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Simon Arinaitwe</h4>
                                        <p className="designation">Chief Content Officer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team3} alt="Bunny Nyangasi Amadi"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Bunny Nyangasi Amadi</h4>
                                        <p className="designation">Head of MaComs</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={blog5} alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Nellie Mary Namayanja</h4>
                                        <p className="designation">Software Engineer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team2} alt="Solomon Ayebare"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Solomon Ayebare</h4>
                                        <p className="designation">Head of Digital Marketing</p>
                                    </div>
                                    <ul className="social-icon">
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                <Parallax className="rn-testimonial-area rn-paralax-testimonial  rn-testimonial-light" bgImage={image7} strength={500} data-black-overlay="5">
                    <div className="testimonial-area ptb--120" data-black-overlay="6">
                        <div className="container">
                            <Testimonial />
                        </div>
                    </div>
                </Parallax>
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Brand />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default About
